import type { ImgHTMLAttributes } from "react";

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  /** 图片名,不带扩展名。同名有 .avif / .webp / .jpg 以及 -600 的小尺寸 */
  name: string;
  /** 这张图在页面上显示多宽,给 sizes 用 */
  sizes: string;
}

/**
 * 同一张图交给浏览器挑:先按格式(AVIF → WebP → JPEG),再按需要的尺寸(600 或 1200 宽)。
 * 生成这些文件的是 scripts/gen-images.mjs。
 */
export function Pic({ name, sizes, ...rest }: Props) {
  const set = (ext: string) => `/img/${name}-600.${ext} 600w, /img/${name}.${ext} 1200w`;
  return (
    <picture>
      <source type="image/avif" srcSet={set("avif")} sizes={sizes} />
      <source type="image/webp" srcSet={set("webp")} sizes={sizes} />
      <img src={`/img/${name}.jpg`} srcSet={set("jpg")} sizes={sizes} width="1200" height="900" {...rest} />
    </picture>
  );
}
